// Admin Console routes

import { visionURL } from "../../src/config/environment";

export const appPrefix = "admin";
export const root = `/${appPrefix}`;
export const dashboard = `${root}/dashboard`;
export const administration = `${root}/administration`;
export const content = `${root}/content`;
export const policies = `${root}/policies`;
export const performance = `${root}/performance`;
export const validate = `${root}/validate`;
export const communications = `${root}/communications`;
export const settings = `${root}/settings`;
export const resources = `${root}/resources`;
export const announcements = `${root}/announcements`;
export const announcementsList = `${announcements}/list`;
export const announcementsCreate = `${announcements}/create`;
export const calendar = `${root}/calendar`;
export const support = `${root}/support`;
export const profile = `${root}/profile`;
export const messages = `${root}/messages`;
export const homeworkSubmission = `${root}/homework-submission/:homeworkSubmissionId`;
export const legacySubmission = `${root}/legacy-submission/:legacySubmissionId`;

export const resourceViewer = `${root}/resource-sections/:sectionId/items/:itemId`;
export const orderALaCartShop = `${validate}/order-a-la-carte-shop`;

export const communicationsMessages = `${communications}/messages`;
export const communicationsAlerts = `${communications}/email-alerts`;

export const repositories = `${content}/repositories`;
export const manageRepository = `${repositories}/:repositoryId`;
export const addRepositoryItem = `${manageRepository}/add-item`;
export const manageRepositoryItem = `${manageRepository}/manage-item/:itemId`;
export const addRepositoryItemVersion = `${manageRepositoryItem}/add-version`;
export const repositoryItemAssociatedFiles = `${manageRepositoryItem}/associated-files`;
export const repositoryItemAssociatedCourses = `${manageRepositoryItem}/associated-training`;
export const showRepositoryItemVersion = `${manageRepositoryItem}/version/:versionId`;

export const adminPolicies = `${content}/policies`;
export const policyDetails = `${adminPolicies}/:policyId/details`;
export const policyDetailsVersions = `${policyDetails}/versions`;
export const policyDetailsAssignments = `${policyDetails}/assignments`;
export const policyDetailsExclusions = `${policyDetails}/exclusions`;
export const policyDetailsSettings = `${policyDetails}/settings`;
export const policyVersion = `${adminPolicies}/:policyId/version/:versionId`;
export const policyVersionDetails = `${policyVersion}/details`;
export const addNewPolicyDocument = `${policyVersion}/policy-editor/:policyDocumentId`;

export const courses = `${content}/courses`;
export const courseDetails = `${courses}/:courseId/details`;
export const courseDetailsSettings = `${courseDetails}/settings`;
export const courseDetailsVersions = `${courseDetails}/versions`;
export const courseDetailsSessions = `${courseDetails}/sessions`;
export const courseDetailsAssignments = `${courseDetails}/assignments`;
export const courseDetailsExclusions = `${courseDetails}/exclusions`;
export const courseDetailsRecordings = `${courseDetails}/recordings`;
export const courseSetPrereqs = `${courses}/:courseId/set-prerequisites`;
export const policySetPrereqs = `${adminPolicies}/:courseId/set-prerequisites`;
export const courseScheduleSession = `${courses}/:courseId/schedule-session`;
export const courseVersion = `${courses}/:courseId/version/:versionId`;
export const manage = `${courses}/manage`;
export const scheduleSessionManage = `${courseScheduleSession}/manage`;
export const courseDetailsManage = `${courseDetails}/:courseDetailsTab/manage`;
export const manageLocations = `${manage}/locations`;
export const manageVirtualClassrooms = `${manage}/virtual-classrooms`;
export const courseVersionDetails = `${courseVersion}/details`;
export const courseVersionHomework = `${courseVersion}/homework`;
export const courseSession = `${courses}/:courseId/session/:sessionId`;
export const courseSessionDetails = `${courseSession}/details`;
export const courseSessionHomework = `${courseSession}/homework`;
export const courseSessionAttendance = `${courseSession}/attendance`;
export const courseSessionEnrollEmployees = `${courseSession}/enroll-employees`;
export const courseBuilder = `${courses}/:courseId/:versionId/course-builder`;
export const courseBuilderContents = `${courseBuilder}/contents`;
export const courseBuilderResources = `${courseBuilder}/resources`;

export const administrationEmployee = `${administration}/employees/:employeeID`;
export const administrationEmployeeEditProfile = `${administration}/employees/:employeeId/profile`;
export const administrationEmployees = `${administration}/employees`;
export const administrationLocations = `${administration}/locations`;
export const administrationLocation = `${administrationLocations}/:locationId`;
export const administrationLocationInfo = `${administrationLocation}/information`;
export const administrationLocationAssignments = `${administrationLocation}/assignments`;
export const administrationLocationAddAssignment = `${administrationLocationAssignments}/add-assignment`;
export const administrationPositions = `${administration}/positions`;
export const administrationPosition = `${administrationPositions}/:positionId`;
export const administrationPositionInfo = `${administrationPosition}/information`;
export const administrationPositionAssignments = `${administrationPosition}/assignments`;
export const administrationPositionAddAssignment = `${administrationPositionAssignments}/add-assignment`;
export const administrationSpecialAssignments = `${administration}/special-assignments`;
export const manageSpecialAssignment = `${administrationSpecialAssignments}/:specialAssignmentId`;
export const administrationGroups = `${administration}/groups`;
export const administrationBulkAssignmentTool = `${administration}/bulk-assignment-tool`;
export const administrationGroupLeaders = `${administration}/groups/:groupID/leaders`;
export const administrationGroup = `${administrationGroups}/:groupId`;
export const administrationGroupInfo = `${administrationGroup}/information`;
export const administrationGroupManagePositions = `${administrationGroupInfo}/manage-positions`;
export const administrationGroupManageLocations = `${administrationGroupInfo}/manage-locations`;
export const administrationGroupAssignments = `${administrationGroup}/assignments`;
export const administrationGroupAddAssignment = `${administrationGroupAssignments}/add-assignment`;

export const validateOrder = `${validate}/order/:orderId`;
export const validateOrderDetails = `${validateOrder}/details`;
export const validateOrderAssignments = `${validateOrder}/assignments`;

export const featureSettings = `${settings}/featureSettings`;
export const featureSettingsRolesPermissions = `${featureSettings}/rolesPermissionsSettings`;
export const featureSettingsGlobalAssignment = `${featureSettings}/globalAssignmentSettings`;
export const repositoryIntegrations = `${settings}/integrations`;
export const policySettings = `${settings}/policies`;

export const emailTranscriptReportURL = `${visionURL}/learning_center/api/performance/transcript_reports/email?`;
export const printTranscriptReportURL = `${visionURL}/learning_center/api/performance/transcript_reports/print?`;

// Helper functions to build Admin Console routes that contain parameters

export const buildHomeworkSubmissionRoute = homeworkSubmissionId =>
  `${root}/homework-submission/${homeworkSubmissionId}`;

export const buildLegacySubmissionRoute = legacySubmissionId =>
  `${root}/legacy-submission/${legacySubmissionId}`;

export const buildManageRespositoryRoute = repositoryId =>
  `${repositories}/${repositoryId}`;

export const buildAddRepositoryItemRoute = repositoryId =>
  `${buildManageRespositoryRoute(repositoryId)}/add-item`;

export const buildManageRepositoryItemRoute = (repositoryId, itemId) =>
  `${buildManageRespositoryRoute(repositoryId)}/manage-item/${itemId}`;

export const buildAddRepositoryItemVersionRoute = (repositoryId, itemId) =>
  `${buildManageRepositoryItemRoute(repositoryId, itemId)}/add-version`;

export const buildRepositoryItemAssociatedFilesRoute = (repositoryId, itemId) =>
  `${buildManageRepositoryItemRoute(repositoryId, itemId)}/associated-files`;

export const buildRepositoryItemAssociatedCoursesRoute = (
  repositoryId,
  itemId
) =>
  `${buildManageRepositoryItemRoute(repositoryId, itemId)}/associated-training`;

export const buildShowRepositoryItemVersionRoute = (
  repositoryId,
  itemId,
  versionId
) =>
  `${buildManageRepositoryItemRoute(
    repositoryId,
    itemId
  )}/version/${versionId}`;

export const buildPolicyDetailsRoute = policyId =>
  `${adminPolicies}/${policyId}/details`;

export const buildPolicyDetailsTabRoute = (policyId, tab) =>
  `${buildPolicyDetailsRoute(policyId)}/${tab}`;

export const buildPolicyDetailsSettingsRoute = policyId =>
  `${buildPolicyDetailsRoute(policyId)}/settings`;

export const buildPolicyDetailsVersionsRoute = policyId =>
  `${buildPolicyDetailsRoute(policyId)}/versions`;

export const buildPolicyDetailsExclusionsRoute = policyId =>
  `${buildPolicyDetailsRoute(policyId)}/exclusions`;

export const buildPolicyDetailsAssignmentsRoute = policyId =>
  `${buildPolicyDetailsRoute(policyId)}/assignments`;

export const buildPolicyVersionRoute = (policyId, versionId) =>
  `${adminPolicies}/${policyId}/version/${versionId}`;

export const buildPolicyVersionDetailsRoute = (policyId, versionId) =>
  `${buildPolicyVersionRoute(policyId, versionId)}/details`;

export const buildAddNewPolicyDocumentRoute = (
  policyId,
  versionId,
  policyDocumentId
) =>
  `${buildPolicyVersionRoute(
    policyId,
    versionId
  )}/policy-editor/${policyDocumentId}`;

export const buildCourseDetailsRoute = courseId =>
  `${courses}/${courseId}/details`;

export const buildCourseDetailsTabRoute = (courseId, tab) =>
  `${buildCourseDetailsRoute(courseId)}/${tab}`;

export const buildCourseDetailsSettingsRoute = courseId =>
  `${buildCourseDetailsRoute(courseId)}/settings`;

export const buildCourseDetailsVersionsRoute = courseId =>
  `${buildCourseDetailsRoute(courseId)}/versions`;

export const buildCourseDetailsSessionsRoute = courseId =>
  `${buildCourseDetailsRoute(courseId)}/sessions`;

export const buildCourseDetailsAssignmentsRoute = courseId =>
  `${buildCourseDetailsRoute(courseId)}/assignments`;

export const buildCourseDetailsExclusionsRoute = courseId =>
  `${buildCourseDetailsRoute(courseId)}/exclusions`;

export const buildCourseDetailsRecordingsRoute = courseId =>
  `${buildCourseDetailsRoute(courseId)}/recordings`;

export const buildCourseVersionRoute = (courseId, versionId) =>
  `${courses}/${courseId}/version/${versionId}`;

export const buildCourseVersionDetailsRoute = (courseId, versionId) =>
  `${buildCourseVersionRoute(courseId, versionId)}/details`;

export const buildCourseVersionHomeworkRoute = (courseId, versionId) =>
  `${buildCourseVersionRoute(courseId, versionId)}/homework`;

export const buildCourseBuilderRoute = (courseId, versionId) =>
  `${courses}/${courseId}/${versionId}/course-builder`;

export const buildCourseBuilderContentsRoute = (courseId, versionId) =>
  `${buildCourseBuilderRoute(courseId, versionId)}/contents`;

export const buildCourseBuilderResourcesRoute = (courseId, versionId) =>
  `${buildCourseBuilderRoute(courseId, versionId)}/resources`;

export const buildCourseSetPrereqsRoute = courseId =>
  `${courses}/${courseId}/set-prerequisites`;

export const buildPolicySetPrereqsRoute = courseId =>
  `${adminPolicies}/${courseId}/set-prerequisites`;

export const buildScheduleSessionRoute = courseId =>
  `${courses}/${courseId}/schedule-session`;

export const buildCourseSessionRoute = (courseId, sessionId) =>
  `${courses}/${courseId}/session/${sessionId}`;

export const buildCourseSessionDetailsRoute = (courseId, sessionId) =>
  `${buildCourseSessionRoute(courseId, sessionId)}/details`;

export const buildCourseSessionHomeworkRoute = (courseId, sessionId) =>
  `${buildCourseSessionRoute(courseId, sessionId)}/homework`;

export const buildCourseSessionAttendanceRoute = (courseId, sessionId) =>
  `${buildCourseSessionRoute(courseId, sessionId)}/attendance`;

export const buildCourseSessionEnrollEmployeesRoute = (courseId, sessionId) =>
  `${buildCourseSessionRoute(courseId, sessionId)}/enroll-employees`;

export const buildEmployeeDetailRoute = employeeId =>
  `${administration}/employees/${employeeId}`;

export const buildEmployeeDetailInformationRoute = employeeId =>
  `${administration}/employees/${employeeId}/information`;

export const buildEmployeeIltRoute = employeeId =>
  `${administration}/employees/${employeeId}/ilt`;

export const buildEmployeeDetailEditProfileRoute = employeeId =>
  `${administration}/employees/${employeeId}/profile`;

export const buildValidateOrderRoute = orderId =>
  `${validate}/order/${orderId}`;

export const buildValidateOrderDetailsRoute = orderId =>
  `${buildValidateOrderRoute(orderId)}/details`;

export const buildValidateOrderAssignmentsRoute = orderId =>
  `${buildValidateOrderRoute(orderId)}/assignments`;

export const buildEmployeeAssignmentsRoute = employeeId =>
  `${administration}/employees/${employeeId}/assignments`;

export const buildEmployeeDetailTranscriptRoute = employeeId =>
  `${administration}/employees/${employeeId}/transcript`;

export const buildCourseDetailsManageRoute = (courseId, currentTab) =>
  `${buildCourseDetailsRoute(courseId)}/${currentTab}/manage`;

export const buildScheduleSessionManageRoute = courseId =>
  `${buildScheduleSessionRoute(courseId)}/manage`;

export const buildGroupDetailInformationRoute = groupId =>
  `${administrationGroups}/${groupId}/information`;

export const buildGroupDetailAssignmentsRoute = groupId =>
  `${administrationGroups}/${groupId}/assignments`;

export const buildGroupDetailLeadersRoute = groupId =>
  `${administrationGroups}/${groupId}/leaders`;

export const buildSpecialAssignmentSettingsRoute = Id =>
  `${administrationSpecialAssignments}/${Id}/settings`;

export const buildManageSpecialAssignmentRoute = Id =>
  `${administrationSpecialAssignments}/${Id}/assignments`;

export const buildLocationInformationRoute = locationId =>
  `${administrationLocations}/${locationId}/information`;

export const buildLocationAssignmentsRoute = locationId =>
  `${administrationLocations}/${locationId}/assignments`;

export const buildAddLocationAssignmentRoute = locationId =>
  `${buildLocationAssignmentsRoute(locationId)}/add-assignment`;

export const buildPositionInformationRoute = positionId =>
  `${administrationPositions}/${positionId}/information`;

export const buildPositionAssignmentsRoute = positionId =>
  `${administrationPositions}/${positionId}/assignments`;

export const buildAddPositionAssignmentRoute = positionId =>
  `${buildPositionAssignmentsRoute(positionId)}/add-assignment`;

export const buildGroupInformationRoute = groupId =>
  `${administrationGroups}/${groupId}/information`;

export const buildGroupAssignmentsRoute = groupId =>
  `${administrationGroups}/${groupId}/assignments`;

export const buildAddGroupAssignmentRoute = groupId =>
  `${buildGroupAssignmentsRoute(groupId)}/add-assignment`;

export const buildGroupManagePositionsRoute = groupId =>
  `${buildGroupInformationRoute(groupId)}/manage-positions`;

export const buildGroupManageLocationsRoute = groupId =>
  `${buildGroupInformationRoute(groupId)}/manage-locations`;

export const buildGroupManageMembersRoute = groupId =>
  `${administrationGroups}/${groupId}/manage-members`;
